import Vue from "vue/dist/vue.esm";
// race info のデータを元に生成するコンポーネント
// keirin jushou の投票、確認画面でのみ使用するコンポーネント
var graphSupportRates = Vue.extend({
  data: function() {
    return {}
  },
  template: `
    <table class="race-graph-table w100per mb10">
      <tr class="bg-base">
        <th></th>
        <th v-for="(entry, key) in state.entries[state.selectedRaceIndex]" v-if="entry.on_sale">
          {{key}}
        </th>
      </tr>
      <tr>
        <td class="vat h100per">
          <ul class="race-graph-sidelist">
            <li v-for="(race, index) in state.entries" @click.prevent="state.selectedRaceIndex = index" :class="{'is-active': state.selectedRaceIndex === index}">
              <div>{{state.box.wins_begin_race_num + index}}R</div>
            </li>
          </ul>
        </td>
        <td v-for="(entry, key) in state.entries[state.selectedRaceIndex]" @click.prevent="entry.vote = !entry.vote;" :class="[{'is-active': entry.vote}, {'is-disabled': entry.kessha}]" v-if="entry.on_sale">
          <table class="race-graph-table-col">
            <tr>
              <td class="h250">
                <div class="graph" :class="['graph-' + key]" :style="{height: getSupportRates(key, true) + '%' }" v-show="getSupportRates(key) > 0"></div>
              </td>
            </tr>
            <tr class="race-graph-helper">
              <td>
                <p>{{getSupportRates(key, true) || '0'}}％</p>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  `,
  methods: {
    // 第二引数をtrueで割合を整数以下切り捨てで返す
    // TODO: 支持率、状況で同じ処理なので共通化する getVoting getSupportRates
    getSupportRates: function(key, isPercentage) {
      if (this.state.support_rates.length > 0) {
        if (isPercentage) {
          // NOTE:下記日付より前は支持率データが計算済み、下記日付含む未来はフロント側で計算
          // TODO:サーバーAPI側にロジックを移す
          var switchDate = new Date('2018-8-22');
          var targetDate = new Date(this.state.open_day);

          if (switchDate > targetDate) {
            return this.state.support_rates[this.state.selectedRaceIndex].votes[key];
          } else {
            var val = chari.util.adjustNum((this.state.support_rates[this.state.selectedRaceIndex].votes[key] / this.state.support_rates[this.state.selectedRaceIndex].total_votes) * 100, 0, false);
            if (!isNaN(val.toFixed(0))) return val.toFixed(0);
          }
        } else {
          // 表示切り替え用
          return this.state.support_rates[this.state.selectedRaceIndex].votes[key];
        }
      }
    }
  }
});

export default {
  graphSupportRates
}
